import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import NumberFormat from 'react-number-format';
import Typography from "@material-ui/core/Typography";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px',
    marginRight: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const CreditLimit = ({
  type,
  onChange,
  value,
  error,
  children,
  disabled,
  title,
  credit_limit_data,
  payment_deals,
  ...props
}) => {


  const handleChange = event => {
    onChange(event, 'credit_limit_data')
  }

  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      <NumberFormat 
            id="first_limit"
            name="first_limit"
            label="Primer límite de crédito"
            placeholder="Ingrese el límite de crédito"
            disabled={disabled}
            required
            className="mt-3 mr-2"
            InputProps={{style: {fontSize: '0.75rem', width: 250}}}
            value={credit_limit_data.first_limit}
            onChange={handleChange}
            error= {(credit_limit_data.second_limit > 0 && credit_limit_data.first_limit > credit_limit_data.second_limit) ? true : false}
            helperText={(credit_limit_data.second_limit > 0 && credit_limit_data.first_limit > credit_limit_data.second_limit) ? 'El primer límite debe ser menor que el segundo límite' : ''}                  
            thousandSeparator='.'
            decimalSeparator=','
            prefix={'$'}
            customInput={TextField}  
            InputLabelProps={{
              shrink: true,
            }}
            isAllowed={(values) => {
              let { floatValue } = values;
              floatValue = (floatValue !== undefined) ? floatValue : 0
              return floatValue >= 0;
            }}            

      />
      <NumberFormat 
            id="second_limit"
            name="second_limit"
            label="Segundo límite de crédito"
            placeholder="Ingrese el límite de crédito"
            required
            disabled={disabled}
            className="mt-3 mr-2"
            InputProps={{style: {fontSize: '0.75rem', width: 250}}}
            value={credit_limit_data.second_limit}
            onChange={handleChange}
            thousandSeparator='.'
            decimalSeparator=','
            prefix={'$'}
            customInput={TextField}  
            InputLabelProps={{
              shrink: true,
            }}
            isAllowed={(values) => {
              let { floatValue } = values;
              floatValue = (floatValue !== undefined) ? floatValue : 0
              return floatValue >= 0;
            }}            

      />

      <FormControl className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Término de pago</Typography>
        <Select native name='payment_deadline'
            inputProps={{
              name:"payment_deadline",
              className:"payment_deadline"
            }}
            style={{minWidth: 150, fontSize: '0.75rem'}}
            onChange={handleChange}
            disabled={disabled}
            value={credit_limit_data.payment_deadline}
            input={<Input id="grouped-native-select" name={"payment_deadline"}/>}>
            <option value="" label="Seleccione"/>
            {payment_deals.map((payment_deal) => <option id={payment_deal.name} value={payment_deal.name}>{payment_deal.name}
          </option>)}
        </Select>
      </FormControl>        

{/*
     <TextField
        disabled={disabled}
        type="number"
        label="Plazo de pago en días"
        placeholder="Ingrese el plazo de pago en días"
        required
        id="payment_deadline"
        name="payment_deadline"
        value={credit_limit_data.payment_deadline}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={handleChange}
        className="mt-3 mr-2"
        InputProps={{style:{fontSize: '0.75rem', width: 250}, inputProps: { min: 0}}}
      />
*/}

	</React.Fragment>
	)
}

CreditLimit.defaultProps = {
  type: "text",
  className: "",
}

CreditLimit.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default CreditLimit;	